export default {
  // cancel: 'fas fa-ban',
  // menu: 'fas fa-ellipsis-v',
  action: 'mdi-shovel',
  // milestone: 'mdi-timeline',
  milestone: 'mdi-flag',
  comment: 'mdi-comment',
  harvest: 'mdi-basket-fill',
  'select-all': 'mdi-checkbox-multiple-marked',
  'deselect-all': 'mdi-checkbox-multiple-blank-outline',
  info: 'mdi-information',
  location: 'mdi-map-marker',
  water: 'mdi-watering-can',
  image: 'mdi-image',
  images: 'mdi-image-multiple',

  garden: 'mdi-sprout',
  plant: 'mdi-sprout',

  dashboard: 'mdi-view-dashboard',
  timeline: 'mdi-timeline',
  login: 'mdi-login',
  logout: 'mdi-logout',
}
